/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Body_RequiredInputs */

const en_mail_admin_body_required = /** @type {(inputs: Mail_Admin_Body_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter the message content.`)
};

const de_mail_admin_body_required = /** @type {(inputs: Mail_Admin_Body_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte tragen Sie den Inhalt ein.`)
};

/**
* | output |
* | --- |
* | "Please enter the message content." |
*
* @param {Mail_Admin_Body_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_body_required = /** @type {((inputs?: Mail_Admin_Body_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Body_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_body_required(inputs)
	return en_mail_admin_body_required(inputs)
});